/**
 * Legacy module shell — kept so AngularJS modules that declare
 * 'acme.common.service.themesHelper' as a dependency keep bootstrapping.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/themes-helper/themes-helper.service.ts
 *
 * It is registered with AngularJS via downgradeInjectable in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * so any $inject = ['ThemesHelperService'] still resolves to the Angular 18 class.
 *
 * Loaded automatically by ui/src/legacy.ts (require.context).
 */
angular.module('acme.common.service.themesHelper', []);
